import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ErrorWarning } from '../models/error-warning.model';
import {
  ErrorWarningModalData,
  ErrorWarningModalOptions,
  ErrorWarningModalSource
} from '../models/error-warning-modal-data.model';

type ErrorWarningConfirmation = { uuid: number; event: 'cancel' | 'continue' };

@Injectable({
  providedIn: 'root'
})
export class ErrorWarningService {
  private _id = 1;
  private _errorWarningsData = new Subject<ErrorWarningModalData>();
  private _confirmations$ = new Map<number, Subject<ErrorWarningConfirmation>>();
  readonly errorWarnings$ = this._errorWarningsData.asObservable();

  displayErrorWarnings(
    source: ErrorWarningModalSource,
    errorWarnings: ErrorWarning,
    options?: ErrorWarningModalOptions
  ): Observable<ErrorWarningConfirmation> {
    const uuid = this._id++;
    const data = {
      uuid,
      data: errorWarnings,
      source,
      options
    };
    const confirmation$ = new Subject<ErrorWarningConfirmation>();
    this._confirmations$.set(uuid, confirmation$);
    this._errorWarningsData.next(data);

    return confirmation$.asObservable();
  }

  continue(uuid: number): void {
    if (!this._confirmations$.has(uuid)) {
      return;
    }

    const confirmation$ = this._confirmations$.get(uuid);
    this._confirmations$.delete(uuid);
    confirmation$.next({ uuid, event: 'continue' });
    confirmation$.complete();
  }

  cancel(uuid: number): void {
    if (!this._confirmations$.has(uuid)) {
      return;
    }

    const confirmation$ = this._confirmations$.get(uuid);
    this._confirmations$.delete(uuid);
    confirmation$.next({ uuid, event: 'cancel' });
    confirmation$.complete();
  }
}
